module.exports = {
  "dof-cell": {
    "position": "relative",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingLeft": "32",
    "backgroundColor": "#ffffff"
  },
  "active-cell": {
    "backgroundColor:active": "#f5f5f5"
  },
  "cell-margin": {
    "marginBottom": "16"
  },
  "cell-title": {
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "marginRight": "50",
    "flex": 1
  },
  "cell-top-border": {
    "borderTopColor": "#f2f2f2",
    "borderTopWidth": "1"
  },
  "cell-bottom-border": {
    "borderBottomStyle": "solid",
    "borderBottomWidth": "1",
    "borderBottomColor": "#f2f2f2"
  },
  "ios-bottom-border": {
    "borderBottomStyle": "solid",
    "borderBottomWidth": "1",
    "borderBottomColor": "#f2f2f2"
  },
  "dof-sub-cell": {
    "flex": 1,
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "paddingRight": "32"
  },
  "dof-sub-cell-inner": {
    "flex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "cell-sub-top-border": {
    "borderTopColor": "#f2f2f2",
    "borderTopWidth": "1"
  },
  "cell-sub-bottom-border": {
    "borderBottomWidth": "1",
    "borderBottomStyle": "solid",
    "borderBottomColor": "#f2f2f2"
  },
  "ios-sub-bottom-border": {
    "borderBottomWidth": "1",
    "borderBottomStyle": "solid",
    "borderBottomColor": "#f2f2f2"
  },
  "cell-arrow-icon": {
    "width": "40",
    "height": "40"
  },
  "content": {
    "flexDirection": "column",
    "flex": 1
  },
  "cell-content": {
    "display": "flex",
    "lines": 1,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "lineHeight": "32",
    "color": "#1E2E37",
    "textOverflow": "ellipsis"
  },
  "cell-content-no-arrow": {
    "display": "flex",
    "lines": 1,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "lineHeight": "32",
    "color": "#1E2E37",
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "hasTag": {
    "maxWidth": "380"
  },
  "noTag": {
    "flex": 1
  },
  "cell-desc-text": {
    "color": "#8E969B",
    "fontSize": "24",
    "lineHeight": "32",
    "marginTop": "20",
    "marginRight": "80",
    "lines": 1,
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "item-image": {
    "marginRight": "24"
  },
  "rightTip": {
    "alignSelf": "flex-start",
    "fontSize": "24",
    "color": "#8E969B"
  },
  "right-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "28",
    "color": "#616C73",
    "textAlign": "right"
  },
  "placeholder-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "28",
    "color": "#c7c7cc",
    "textAlign": "right",
    "flex": 1
  },
  "cell-title-btn": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "24",
    "height": "48",
    "lineHeight": "48",
    "paddingLeft": "20",
    "paddingRight": "20",
    "borderRadius": "24",
    "marginLeft": "20",
    "color": "#616C73",
    "backgroundColor": "#f2f2f2"
  },
  "midea-swipe-cell__right": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#F56428",
    "fontSize": "32",
    "color": "#ffffff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1b718726!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-cell2/index.vue
// module id = 430
// module chunks = 0 1